<template>
  <DashboardSection
    title="Kanal-Maßnahmen-Matrix"
    subtitle="Spaltenköpfe und Zellen führen zur gefilterten Detailseite"
    :empty="!rows.length"
    empty-text="Keine Kampagnen im ausgewählten Zeitraum."
  >
    <TableScroll label="Kanal-Maßnahmen-Matrix">
      <table class="mb-matrix">
        <thead>
          <tr>
            <th scope="col">Projekt</th>
            <th scope="col">Kampagne</th>
            <!-- UX: Spaltenköpfe sind jetzt Kanal-Einstiege (übernehmen die Filter). -->
            <th v-for="channel in channels" :key="channel.code" scope="col">
              <router-link
                :to="columnLink(channel)"
                class="mb-matrix__head"
                :style="{ '--mb-lane': `var(--mb-channel-${channel.code})` }"
              >
                <span class="mb-swim__lane-dot" aria-hidden="true" />{{ channel.name }}
              </router-link>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in rows" :key="row.campaign_id">
            <td>{{ row.project }}</td>
            <td>{{ row.campaign }}</td>
            <td v-for="channel in channels" :key="channel.code">
              <router-link
                v-if="row.cells[channel.code]?.present"
                :to="cellLink(row, channel)"
                class="mb-dot mb-dot--link"
                :style="{ '--mb-lane': `var(--mb-channel-${channel.code})` }"
                :aria-label="`${row.cells[channel.code].count} Maßnahmen ${channel.name} – ${row.campaign}`"
              >
                {{ row.cells[channel.code].count }}
              </router-link>
              <span v-else class="mb-dot off" aria-label="keine Maßnahme">–</span>
            </td>
          </tr>
        </tbody>
      </table>
    </TableScroll>
  </DashboardSection>
</template>

<script setup>
import { computed } from 'vue';
import { CHANNEL_ROUTES } from '../composables/formatters';
import { useMarketingFilters } from '../composables/useMarketingFilters';
import DashboardSection from './DashboardSection.vue';
import TableScroll from './TableScroll.vue';

const props = defineProps({
  matrix: { type: Object, default: () => ({ channels: [], rows: [] }) }
});

const { queryFor } = useMarketingFilters();

const channels = computed(() => props.matrix.channels || []);
const rows = computed(() => props.matrix.rows || []);

function columnLink(channel) {
  const name = CHANNEL_ROUTES[channel.code];
  if (!name) return { path: '/marketing', query: queryFor('marketing-overview') };
  return { name, query: queryFor(name) };
}

function cellLink(row, channel) {
  const name = CHANNEL_ROUTES[channel.code];
  const query = {
    ...queryFor(name),
    project_id: String(row.project_id || ''),
    campaign_id: String(row.campaign_id || '')
  };
  if (!name) return { path: '/marketing', query };
  return { name, query };
}
</script>
